import { render, staticRenderFns } from "./SharingProfileCode.vue?vue&type=template&id=2406faf3"
import script from "./SharingProfileCode.vue?vue&type=script&lang=js"
export * from "./SharingProfileCode.vue?vue&type=script&lang=js"
import style0 from "./SharingProfileCode.vue?vue&type=style&index=0&id=2406faf3&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2406faf3')) {
      api.createRecord('2406faf3', component.options)
    } else {
      api.reload('2406faf3', component.options)
    }
    module.hot.accept("./SharingProfileCode.vue?vue&type=template&id=2406faf3", function () {
      api.rerender('2406faf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/SharingProfileCode.vue"
export default component.exports